import axios from "../axiosConfig";

class Routes {
  login(data) {
    return axios.post("/auth/login", data);
  }
  signup(data) {
    return axios.post("/auth/signup", data);
  }
  forgetPassword(data) {
    return axios.post("/auth/forget-password", data);
  }
  resetPassword(data) {
    return axios.post("/auth/reset-password", data);
  }

  resetPasswordAdmin(data) {
    return axios.post("/auth/reset-password-admin", data);
  }
  deleteCustomer(id) {
    return axios.delete(`/auth/${id}`);
  }
}

export default new Routes();
